class CustomSlider extends HTMLElement {
  constructor() {
    super();

    //Extraemos el id del slider
    this.sliderId = this.getAttribute("id");

    //Con el id seleccionamos los botones y el wrapper relacionados
    this.buttonPrev = document.querySelector(`#prev-${this.id}`);
    this.buttonNext = document.querySelector(`#next-${this.id}`);
    this.wrapper = this.querySelector(`#wrapper-${this.id}`);

    /* Con la propiedad slideWidth decidimos qué tanto se desplaza. Se pasa el parámetro en slide-width.
        Si es "auto", se usará el tamaño del contenedor.
        Sino, se usará el valor numérico que se pase. */
    if (this.getAttribute("slide-width") === "auto") {
      this.slideWidth = this.getBoundingClientRect().width;
      window.addEventListener("resize", () => {
        this.slideWidth = this.getBoundingClientRect().width;
      });
    } else {
      this.slideWidth = Number(this.getAttribute("slide-width"));
    }

    /* itemsPerSlide es un atributo que dirá cuántos items hay en cada slide (1 o 2). Esto sirve para llevar la 
        cuenta de currentSlide.
        */
    this.itemsPerSlide = Number(this.getAttribute("items-per-slide"));

    //Representa cuantos slides se estan mostrando ahora mismo
    this.showedItems = Number(this.getAttribute("showing-items"));

    //totalSlides serán la cantidad de slides que tengamos. CurrenSlide en qué slide vamos.
    this.totalSlides = Math.floor(
      document.querySelectorAll(`.slide-${this.id}`).length / this.itemsPerSlide
    );

    //Esta propiedad solo va a existir en la página de producto, y se usará para cambiar las fotos del slider
    this.variant = this.getAttribute("variant");


    this.currentSlide = Number(this.wrapper.dataset.currentSlide);

    //Se agrega el contexto this a las funciones para que accedan al this.wrapper
    this.prevSlide = this.prevSlide.bind(this);
    this.nextSlide = this.nextSlide.bind(this);
    this.toggleButtons = this.toggleButtons.bind(this);

    //Agregamos los eventos a los botones para ir a la siguiente o anterior slide
    this.buttonPrev.addEventListener("click", this.prevSlide);
    this.buttonNext.addEventListener("click", this.nextSlide);
  }

  connectedCallback() {
    const amount = document.querySelectorAll(`.slide-${this.id}`).length;
    if (this.showedItems >= amount) {
      this.buttonPrev.disabled = true;
      this.buttonNext.disabled = true;
    } else {
      this.classList.add("show-right");
    }
  }

  prevSlide() {
    this.currentSlide--;
    this.wrapper.style.transform = `translateX(-${
      this.currentSlide * this.slideWidth
    }px)`;
    this.wrapper.dataset.currentSlide = this.currentSlide;
    this.toggleButtons();
  }

  nextSlide() {
    this.currentSlide++;
    this.wrapper.style.transform = `translateX(-${
      this.currentSlide * this.slideWidth
    }px)`;
    this.wrapper.dataset.currentSlide = this.currentSlide;
    this.toggleButtons();
  }

  //Habilita o no a los botones en base al slide por el que va.
  toggleButtons() {
    this.buttonPrev.disabled = this.currentSlide === 0;
    this.buttonNext.disabled =
      this.currentSlide === this.totalSlides - this.showedItems;
    if (this.buttonPrev.disabled) {
      this.classList.remove("show-left");
    } else {
      this.classList.add("show-left");
    }
    if (this.buttonNext.disabled) {
      this.classList.remove("show-right");
    } else {
      this.classList.add("show-right");
    }
  }

  static get observedAttributes() {
    return ["variant"]; // Nombre del atributo que deseas observar
  }

  //Esta función se disparará cuando se cambie la variante de un producto
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "variant" && oldValue) {
      
      //Reiniciamos la posición del slider a 0 y acorde a eso ajustamos el translateX
      this.currentSlide = "0";
      this.wrapper.style.transform = `translateX(-${
        this.currentSlide * this.slideWidth
      }px)`;
      //Actualizamos el atributo
      this.wrapper.dataset.currentSlide = this.currentSlide;
      
      //totalSlides será la nueva cantidad de slides en base a cuantas tienen display.
      const slides = Array.from(document.querySelectorAll(`.slide-${this.id}`));
      const slidesWithDisplayNotNone = slides.filter(
        (slide) => slide.style.display !== "none"
      );
      this.totalSlides = Math.floor(
        slidesWithDisplayNotNone.length / this.itemsPerSlide
      );
      
      //Por defecto el prevBtn será disabled (pq iniciamos en 0) y el nextBtn abled
      this.buttonPrev.disabled = true;
      this.buttonNext.disabled = false;

      //Acá verificamos si debemos desactivar el nextBtn en base a si solo es un slide
      if (this.showedItems >= this.totalSlides) {
        /* this.buttonPrev.disabled = true; */
        this.buttonNext.disabled = true;
      } else {
        this.classList.add("show-right");
      }
    }
  }
}

customElements.define("custom-slider", CustomSlider);

class SliderPicker extends HTMLElement {
  constructor() {
    super();

    //Extraemos el id del <slider-picker>
    this.id = this.getAttribute("id");

    //Seleccionamos los botones dentro del <slider-picker>
    this.options = this.querySelectorAll("button");

    //Los sliders los seleccionamos en base su id y al data-slider-id de los botones
    this.sliders = Array.from(this.options).map((opt) => {
      return document.querySelector(`#${opt.dataset.sliderId}`);
    });

    this.changeSlider = this.changeSlider.bind(this);

    //Asignamos el evento de cambiar de slider. Para eso pasamos el id del slider que esta en el boton.
    this.options.forEach((option) => {
      option.addEventListener("click", () => this.changeSlider(option));
    });
  }

  changeSlider(selectedButton) {
    //Se le quita el "active" a todos los botones y luego se agrega al que se hundió
    this.options.forEach((option) => option.classList.remove("active"));
    selectedButton.classList.add("active");

    this.sliders.forEach((slider) => {
      const container = slider.closest("article");
      container.classList.remove("active");
      container.classList.add("hidden");
      /* container.style.opacity = 0; */
      /* container.style.display = 'none'; */
      setTimeout(() => {
        /* slider.style.display = 'none'; */
      }, 500);
    });

    this.selectedSlider = this.sliders.filter(
      (slide) => slide.id === selectedButton.dataset.sliderId
    )[0];
    const container = this.selectedSlider.closest("article");

    container.classList.remove("hidden");
    /* container.style.display = 'flex'; */
    setTimeout(() => {
      container.classList.remove("opacity-0");
      container.classList.add("active");
    }, 10);
  }
}

customElements.define("slider-picker", SliderPicker);

/* totalSlides serán la cantidad de slides que tengamos. CurrenSlide en qué slide vamos. 
    Acá primero hayamos los slides, y luego filtramos solo los que su display no sea none.
    Esto lo hacemos para la sección de main-product, que no cuente los slides no visibles*/

/* const slides = Array.from(document.querySelectorAll(`.slide-${this.id}`)) */

/* const slidesWithDisplayNotNone = slides.filter(slide=>slide.style.display !== "none") */

/*     this.totalSlides = Math.floor(
      slidesWithDisplayNotNone.length / this.itemsPerSlide
    ); */
